import {Box, Spinner} from '@chakra-ui/react';

const Loader = () => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height={480}
    >
      <Spinner size='xl' />
    </Box>
  );
};

export default Loader;
